import { EntityBase } from "./common";

// ScoringConfig

export interface ScoringConfigModel extends EntityBase {
  pricePerPoint: number;

  minCashabilityScore: number;
  minWithdrawalScore: number;

  minBronzeScore: number;
  minSilverScore: number;
  minGoldScore: number;
  minDiamondScore: number;

  registration: RegistrationConfigModel;
  subscription: SubscriptionConfigModel;

  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface RegistrationConfigModel extends EntityBase {
  score: number;
  scoreWithReferrer: number;
  referrerScore: number;

  vipScore: number;
  vipReferrerScore: number;
}

export interface SubscriptionConfigModel extends EntityBase {
  score: number;
  referrerScore: number;
  referrerValidityYears: number;

  vipReferrerScore: number;
  vipReferrerValidityYears: number;
}

// ScoringLog

export interface ScoringLogModel extends EntityBase {
  userId: string;
  userName?: string;

  isReferrer: boolean;
  referredUserId?: number;
  referredUserName?: string;
  referredReferralCode?: string;

  scoreType: ScoreType;
  givenScore: number;

  subscriptionLog?: SubscriptionLogModel;

  createdAt?: string;
}

export enum ScoreType {
  Registration,
  Subscription,
}

export interface SubscriptionLogModel extends EntityBase {
  subscriptionId: number;
  paiedPrice: number;
  invoiceDate: string;
}

export interface ManualScoringModel {
  userIds?: string[];
  scoreType: ScoreType;
}
